import React from 'react'
// view components
import ReviewBar from 'components/Modals/PlanItems/components/ReviewBar'
// constants
import { Modals } from 'constants/index'
import { REVIEW_STATUSES } from 'constants/review'
// views
import { Button, ButtonLabel, InProgressIndicator } from './views'
// hooks
import { useCurrentUser, useModalData, useShowModal } from 'hooks/index'
// context
import { ReviewDrawerContext } from 'context/ReviewDrawerContext'
// utils
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import { getActiveReview, isUserReviewer } from 'utils/reviews'

// types
interface IIncomingProps {
  entity: any
  isFullModal?: boolean
  isSidebar?: boolean
  hideModal?: () => void
}

const CompleteReview: React.FunctionComponent<IIncomingProps> = ({ entity, isFullModal, isSidebar, hideModal }) => {
  const currentUser = useCurrentUser()

  // the review being created replaces the active one only inside the review drawer, not on the page behind it
  const isInReviewDrawer = React.useContext(ReviewDrawerContext)

  const {
    modalData: { review: reviewToCreate }
  } = useModalData({ modalType: Modals.REVIEW_CREATE_MODAL })
  const { showModal: showReviewCreateModal } = useShowModal({ modalType: Modals.REVIEW_CREATE_MODAL })

  const activeReview = getActiveReview(entity)
  const review = isInReviewDrawer ? reviewToCreate : activeReview
  const isVisible = !!activeReview && !isEmpty(review)

  if (!isVisible) {
    return null
  }

  const reviewStatus = review?.status || REVIEW_STATUSES.NOT_STARTED

  const isCurrentUserReviewer = isUserReviewer(review, currentUser)
  const isInProgress = isInReviewDrawer && reviewToCreate?.scheduledReview?.id === review.scheduledReview.id

  const handleStartReview = () => {
    showReviewCreateModal({ entity, review })

    if (isFullModal) {
      hideModal?.()
    }
  }

  return (
    <ReviewBar review={review} isFullModal={isFullModal} isSidebar={isSidebar}>
      {isInProgress ? (
        <InProgressIndicator container alignItems={'center'}>
          IN PROGRESS
        </InProgressIndicator>
      ) : (
        isCurrentUserReviewer &&
        moment().isSameOrAfter(review.startPeriod, 'day') && (
          <Button data-testid='start-review' $isFullModal={isFullModal || isSidebar} onClick={handleStartReview}>
            <ButtonLabel>{reviewStatus === REVIEW_STATUSES.IN_PROGRESS ? 'FINISH REVIEW' : 'START REVIEW'}</ButtonLabel>
          </Button>
        )
      )}
    </ReviewBar>
  )
}

export default CompleteReview
